module.exports = __webpack_public_path__ + "img/img1.a3ed731f.webp";